<template>
	<v-dialog
		v-model="showDialog"
		max-width="1200px"
		height="90%"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<template v-if="requiredDialogBtn" v-slot:activator="{ on, attrs }">
			<v-btn
				:text="text"
				:color="text ? 'white' : 'secondary'"
				class="ml-2"
				@click.stop="openDialog"
				v-bind="attrs"
				v-on="on"
			>
				<v-icon class="mr-1">mdi-plus</v-icon>
				情報物件詳細
			</v-btn>
		</template>

		<v-card tile height="90vh" class="overflow-hidden">
			<v-app-bar
				dense
				dark
				flat
				color="primary"
				elevate-on-scroll
				scroll-target="#scroll-area"
				extension-height="40px"
			>
				<v-app-bar-title class="color-white">情報物件詳細</v-app-bar-title>
				<v-spacer />
				<v-btn icon dark @click="showDialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
				<template v-slot:extension>
					<v-tabs
						v-model="tab"
						height="40px"
						slider-color="primary"
						background-color="#f0f0f0"
						color="black"
						@change="selectTab"
					>
						<v-tab v-for="(item, i) in tabs" :key="i">
							{{ item.name }}
						</v-tab>
					</v-tabs>
				</template>
			</v-app-bar>
			<v-sheet elevation="0" id="scroll-area" class="overflow-y-auto" height="calc(90vh - 88px)">
				<v-tabs-items v-if="!loading" v-model="tab" class="pa-2" @change="selectTab">
					<MainInfoTab
						:order_individual_info="orderIndividualInfo"
						:processAuthorityFlag="editable && processAuthorityFlag"
						:authorityFlag="editable && authorityFlag"
						:showProcessBtn="showProcessBtn"
						:largeProcessTypes="largeProcessTypes"
						@reset-order-individual-info="fetchOrderIndividualInfo(id)"
						@update-info="updateOrderIndividualInfo($event)"
					/>
					<TestsTab :order_individual_info="orderIndividualInfo" />
					<MatterTab
						:id="orderIndividualInfo ? orderIndividualInfo.id : id"
						:isFetched="isFetched('案件詳細')"
					/>
					<ProductsTab
						:id="orderIndividualInfo ? orderIndividualInfo.id : id"
						@fetch-order-individual-info="fetchOrderIndividualInfo($event)"
						:isFetched="isFetched('製品情報')"
					/>
					<DeliveryInfoTab :order_individual_info="orderIndividualInfo" />
					<HistoryTab :order_individual_info="orderIndividualInfo" :columnNames="column_names" />
					<RequirementsTab
						:id="orderIndividualInfo ? orderIndividualInfo.id : id"
						:isFetched="isFetched('関連依頼')"
					/>
					<AttachedFileTab
						:id="orderIndividualInfo ? orderIndividualInfo.id : id"
						:isFetched="isFetched('添付ファイル')"
					/>
				</v-tabs-items>
				<Loading v-else :isLoading="true" />
			</v-sheet>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"
import PaginationModule from "../../shared/PaginationModule.vue"
import Loading from "../../shared/IndeterminateLoadingView.vue"
import OrderIndividualInfoForm from "./OrderIndividualInfoForm.vue"
import MatterBriefInfo from "./MatterBriefInfo.vue"
import AttachedFileTab from "../tabs/AttachedFileTab.vue"
import MatterTab from "../tabs/MatterTab.vue"
import DeliveryInfoTab from "../tabs/DeliveryInfoTab.vue"
import HistoryTab from "../tabs/HistoryTab.vue"
import MainInfoTab from "../tabs/MainInfoTab.vue"
import TestsTab from "../tabs/TestsTab.vue"
import ProductsTab from "../tabs/ProductsTab.vue"
import RequirementsTab from "../tabs/RequirementsTab.vue"

export default {
	props: {
		text: Boolean,
		requiredDialogBtn: {
			type: Boolean,
			required: false,
			default: false,
		},
		dialog: {
			type: Boolean,
			required: false,
			default: false,
		},
		id: {
			type: null,
			required: false,
		},
		order_individual_info: {
			type: Object,
			required: false,
		},
		showProcessBtn: {
			type: Boolean,
			required: false,
			default: true,
		},
		editable: {
			type: Boolean,
			required: false,
			default: true,
		},
	},
	components: {
		PaginationModule,
		OrderIndividualInfoForm,
		MatterBriefInfo,
		AttachedFileTab,
		MatterTab,
		DeliveryInfoTab,
		HistoryTab,
		MainInfoTab,
		TestsTab,
		ProductsTab,
		RequirementsTab,
		Loading,
	},
	data() {
		return {
			tab: 0,
			tabs: [
				{ name: "情報物件情報", isFetched: false },
				{ name: "検査情報", isFetched: false },
				{ name: "案件詳細", isFetched: false },
				{ name: "製品情報", isFetched: false },
				{ name: "顧客・配達情報", isFetched: false },
				{ name: "変更履歴", isFetched: false },
				{ name: "関連依頼", isFetched: false },
				{ name: "添付ファイル", isFetched: false },
			],
			orderIndividualInfo: null,
			largeProcessTypes: [],
			processAuthorityFlag: false,
			authorityFlag: false,
			matter: null,
			loading: false,
			column_names: {},
		}
	},
	methods: {
		openDialog() {
			this.showDialog = true
		},
		fetchOrderIndividualInfo(id) {
			this.loading = true
			this.tab = 0
			const headers = authenticate.setHeader()
			const url = `/erp/v1/order_individual_infos/${id}`
			axios
				.get(url, { headers })
				.then((res) => {
					// this.showDialog = true
					this.orderIndividualInfo = res.data.individual_info
					this.processAuthorityFlag = res.data.process_authority_flag
					this.authorityFlag = res.data.authority_flag
					this.largeProcessTypes = res.data.large_process_types
					this.column_names = res.data.column_names
					this.tabs.forEach((tab) => (tab.isFetched = false))
					this.selectTab()
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
				.finally(() => this.$nextTick(() => (this.loading = false)))
		},
		selectTab() {
			this.tabs[this.tab].isFetched = true
		},
		updateOrderIndividualInfo(orderIndividualInfo) {
			this.orderIndividualInfo = orderIndividualInfo
			this.$emit("update-info", orderIndividualInfo)
		},
	},
	computed: {
		showDialog: {
			get() {
				return this.dialog
			},
			set(newVal) {
				return this.$emit("update:dialog", newVal)
			},
		},
		isFetched() {
			return (name) => {
				const tab = this.tabs.find((t) => t.name == name)
				return tab != null ? tab.isFetched : false
			}
		},
	},
	watch: {
		order_individual_info(newVal, _) {
			this.orderIndividualInfo = newVal
		},
		id(newVal, oldVal) {
			if (newVal == oldVal) return
			this.fetchOrderIndividualInfo(newVal)
		},
		deep: true,
	},
}
</script>

<style lang="scss" scoped>
.products {
	.row {
		&:not(:first-child) {
			border-top: 1px solid whitesmoke;
		}
	}
}
.theme--dark.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) {
	color: black;
}
</style>
